import { render, staticRenderFns } from "./snav.vue?vue&type=template&id=fb3c6fde"
import script from "./snav.vue?vue&type=script&lang=js"
export * from "./snav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports